import React from 'react';

const Support = ({ lang }) => {
  const content = {
    fr: {
      title: 'Soutenir le projet',
      intro: 'Si vous souhaitez aider financièrement à la maintenance du site et à la production de nouveaux documents, vous pouvez contribuer via les moyens suivants :',
      paypalTitle: 'Don via PayPal',
      paypalDesc: 'Paiement sécurisé par carte bancaire ou compte PayPal',
      paypalBtn: 'Faire un don PayPal',
      bankTitle: 'Virement bancaire',
      bankDesc: 'Vous pouvez également effectuer un virement bancaire :',
      bankHolder: 'Titulaire',
      thanks: 'Merci pour votre soutien !',
      thanksDesc: 'Votre contribution aide à maintenir ce site gratuit et accessible à tous.'
    },
    en: {
      title: 'Support the project',
      intro: 'If you wish to financially support the maintenance of the site and the production of new documents, you can contribute via the following means:',
      paypalTitle: 'Donate via PayPal',
      paypalDesc: 'Secure payment by credit card or PayPal account',
      paypalBtn: 'Donate with PayPal',
      bankTitle: 'Bank transfer',
      bankDesc: 'You can also make a bank transfer:',
      bankHolder: 'Account holder',
      thanks: 'Thank you for your support!',
      thanksDesc: 'Your contribution helps keep this site free and accessible to everyone.'
    }
  };

  const L = content[lang];

  return (
    <div className="support-page">
      <h1>💝 {L.title}</h1>
      
      <p className="support-intro">{L.intro}</p>

      <section className="support-method">
        <h2>📧 {L.paypalTitle}</h2>
        <p>{L.paypalDesc}</p>
        <form action="https://www.paypal.com/donate" method="post" target="_blank">
          <input type="hidden" name="business" value="babdouli@yahoo.fr" />
          <input type="hidden" name="currency_code" value="EUR" />
          <button type="submit" className="btn-paypal">
            🅿️ {L.paypalBtn}
          </button>
        </form>
      </section>

      <section className="support-method">
        <h2>🏦 {L.bankTitle}</h2>
        <p>{L.bankDesc}</p>
        <div className="bank-details">
          <p><strong>{L.bankHolder} :</strong> MONSIEUR BELGACEM ABDOULI</p>
          <p><strong>IBAN :</strong> FR76 3000 4000 6200 0006 1034 628</p>
          <p><strong>BIC :</strong> BNPAFRPPXXX</p>
        </div>
      </section>

      <section className="support-thanks">
        <h2>🙏 {L.thanks}</h2>
        <p>{L.thanksDesc}</p>
      </section>
    </div>
  );
};

export default Support;
